/**
 * 容器填充宽度计算
 * */
import $store from '@/store/index';
import { PAGE_SIZE_CELL } from '@/subjects/constant';

export const getContentWidth = () => {
  const answerSheet = $store.getters['answerPanel/answerSheet'];
  const acCardPanes = answerSheet.acCardPanes;
  const contentWidth = PAGE_SIZE_CELL[acCardPanes == 3 ? 1 : 0] - 2 - 30; //- 2 - 30;
  return contentWidth;
};
